import { FETCH_ISIR_REC_ELEMENT_INFO } from "../actions/types";

const INITIAL_STATE = {
    isirRecElementInfos: []
};

const AdminReducers = (state = INITIAL_STATE, action) =>
{
    switch(action.type)
    {
        case FETCH_ISIR_REC_ELEMENT_INFO:
            return {
                ...state,
                isirRecElementInfos: action.payload
            };
        default:
            return state;
    }
};

export default AdminReducers;
